import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/components/auth/Login";
import Callback from "@/components/auth/Callback";
import Register from "@/components/auth/Register";
import Settings from "@/components/Settings"
import TrackingPage from "@/components/TrackingPage";
import Routes from "@/components/pages/Delivery/Routes";
import Search from "../../components/pages/Delivery/Search";
import SearchDeliveryActionPage from "../../components/pages/Delivery/SearchDeliveryActionPage";
import "vue-material-design-icons/styles.css";
import ManifestsPage from "../../components/pages/Manage/ManifestsPage";
import ExceptionsPage from "../../components/pages/Delivery/ExceptionsPage";
import EditClient from "../../components/EditClient";
import Zones from "../../components/pages/Delivery/Zones";
import ClientsPage from "../../components/pages/Admin/ClientsPage";
import InvoiceUI from "../../components/pages/Manage/InvoicesUI";
import UploadYourManifest from "../../components/pages/Delivery/UploadYourManifest";
import CreateClient from "../../components/CreateClient";
import ManageUsers from "../../components/pages/Manage/ManageUsers";
import ClientApplicationPage from "../../components/pages/Admin/ClientApplicationPage";
import ClientAccess from "../../components/pages/Admin/ClientAccess";
import LogsDisplayer from "../../components/pages/Admin/LogsDisplayer";
import ManageManifests from "../../components/pages/Admin/ManageManifests";
import ManageDevices from "../../components/pages/Manage/ManageDevices";
import HomePage from "../../components/HomePage";
import BadAddressPage from "../../components/pages/Delivery/BadAddressPage";
import ContractorsPage from "../../components/pages/Manage/ContractorsPage";
import GlobalAdmin from "../../components/pages/Admin/GlobalAdmin/GlobalAdmin";
import LateDeliveries from "../../components/pages/Delivery/LateDeliveries";
import ManageItems from "../../components/util/Inventory/ManageItems";
import ManageOrders from "../../components/util/Inventory/ManageOrders";
import Demo from "../../components/pages/Admin/Demo";
import Templates from "../../components/pages/Admin/Templates";
import ManageKeys from "../../components/pages/Manage/ManageKeys/ManageKeys";
import ErrorTracking from "../../components/pages/Delivery/ErrorTracking";
import ZoneMap from "../../components/pages/Delivery/ZoneMap";
import ExcelReportsPage from "../../components/pages/Delivery/ExcelReportsPage";
import InvoicesUpload from "../../components/pages/Manage/InvoicesUpload.vue";
import store from "../store";
import CreateDelivery from "../../components/pages/Delivery/CreateDelivery/CreateDelivery";
import BecoolInfo from "../../components/pages/Manage/BecoolInfo";
import LineHaulPricing from "../../components/pages/Manage/LineHaulPricing";
import Network from "../../components/pages/Admin/Network";
import ValidateAddress from "../../components/pages/Delivery/ValidateAddress";
import Setting from "../../components/pages/Admin/Settings";
import DispatchAllocation from "../../components/pages/Delivery/DispatchAllocation";
import LinehaulSchedule from "../../components/pages/Delivery/LinehaulSchedule"
import LinehaulCalculator from "../../components/pages/Delivery/LinehaulCalculator"
import Runs from "../../components/pages/Delivery/Runs";
import PermissionsManage from "../../components/pages/Manage/PermissionsManage";
import Jobs from "../../components/pages/Admin/Jobs";
import FAQ from "../../components/util/FAQ.vue";
import Production from "../../components/pages/Delivery/Production.vue";
import FuelLevyPricing from "../../components/pages/Manage/FuelLevyPricing.vue";
import PickPackPricing from "../../components/pages/Manage/PickPackPricing.vue";
import DeliverySurchargePricing from "../../components/pages/Manage/DeliverySurchargePricing.vue";
import PalletStoragePricing from "../../components/pages/Manage/PalletStoragePricing.vue";
import DeliveryListing from "../../components/pages/Delivery/DeliveryListing.vue";


Vue.use(VueRouter);

let routes = [
  {
    path: "/login",
    name: "Login",
    icon: "edit",
    meta: {},
    component: Login
  },
  {
    path: "/register",
    name: "Register",
    icon: "edit",
    meta: {},
    component: Register
  },
  {
    path: "/callback",
    name: "Callback",
    meta: { header: false, subheader: false },
    icon: "fas fa-circle-notch fa-spin",
    component: Callback,
  },
  {
    path: "/trackingPage",
    name: "TrackPage",
    icon: "fas fa-search-location",
    meta: {},
    component: TrackingPage
  },
  {
    path: "/settings",
    name: "Settings",
    meta: { login: true },
    icon: "fas fa-user-cog",
    component: Settings,
  },
  {
    path: "/",
    name: "Home",
    meta: { login: true, header: true },
    icon: "fas fa-home",
    component: HomePage,
  },
  {
    path: "/create_delivery",
    name: "Create",
    meta: { permission: 'manual_create', login: true, subheader: 'Delivery' },
    icon: "fas fa-plus-circle",
    component: CreateDelivery,
  },
  {
    path: "/search",
    name: "Search",
    meta: { permission: 'delivery_view', login: true, subheader: 'Delivery' },
    icon: "fas fa-search",
    component: Search,
  },
  {
    path: "/delivery-list",
    name: "List",
    meta: { permission: 'delivery_view', login: true, subheader: 'Delivery' },
    icon: "fas fa-list",
    component: DeliveryListing,
  },
  {
    path: "/search-mass-action",
    name: "Search (mass action)",
    meta: { permission: 'delivery_admin', login: true, subheader: 'Delivery', internalOnly: true },
    icon: "fas fa-search-plus",
    component: SearchDeliveryActionPage,
  },
  {
    path: "/zones",
    name: "Zones",
    icon: "fas fa-globe-asia",
    meta: { permission: 'zone_view', login: true, subheader: 'Delivery' },
    component: Zones,
  },
  {
    path: "/zoneMap",
    name: "Zone Map",
    icon: "fas fa-map-marker-alt",
    meta: { permission: 'zone_view', login: true, subheader: 'Delivery' },
    component: ZoneMap,
  },
  {
    path: "/upload_manifest",
    name: "Upload your manifest",
    meta: { permission: 'manifest_view', login: true, subheader: 'Delivery' },
    icon: "fas fa-file-upload",
    component: UploadYourManifest,
  },
  {
    path: "/exceptions",
    name: "Exceptions",
    icon: "fas fa-exclamation-triangle",
    meta: { permission: 'delivery_view', login: true, subheader: 'Delivery' },
    component: ExceptionsPage,
  },
  {
    path: "/late_deliveries",
    name: "Late Deliveries",
    meta: { permission: "delivery_view", login: true, subheader: 'Delivery' },
    icon: "far fa-clock",
    component: LateDeliveries
  },
  {
    path: "/manage_users",
    name: "Users",
    meta: { permission: 'user_view', login: true, subheader: 'Manage' },
    icon: "fas fa-user-tie",
    component: ManageUsers,
  },
  {
    path: "/bad_address",
    name: "Bad Addresses",
    meta: { permission: 'bad_address_view', login: true, subheader: 'Delivery' },
    icon: "not_listed_location",
    component: BadAddressPage,
  },
  {
    path: "/validate_address",
    name: "Validate Addresses",
    meta: { permission: 'delivery_view', login: true, subheader: 'Delivery' },
    icon: "fa fa-university",
    component: ValidateAddress,
  },
  {
    path: "/runs",
    name: "Runs",
    meta: { permission: 'delivery_view', login: true, subheader: 'Delivery', internalOnly: true },
    icon: "production_quantity_limits",
    component: Runs,
  },
  {
    path: "/error_tracking",
    name: "Error Tracking",
    meta: { permission: 'error_view', login: true, subheader: 'Delivery' },
    icon: "fas fa-exclamation-circle",
    component: ErrorTracking,
  },
  {
    path: "/excel_report",
    name: "Excel Reports",
    meta: { permission: 'error_edit', login: true, header: false, subheader: 'Delivery', internalOnly: true },
    icon: "fas fa-file-excel",
    component: ExcelReportsPage
  },
  {
    path: "/routes",
    name: "Routes",
    meta: { permission: 'route_view', login: true, subheader: 'Delivery', internalOnly: true },
    icon: "fas fa-route",
    component: Routes,
  },
  {
    path: "/allocation",
    name: "Dispatch allocation",
    meta: { permission: 'delivery_view', login: true, subheader: 'Delivery' },
    icon: "fas fa-cubes",
    component: DispatchAllocation,
  },
  {
    path: "/linehaulschedule",
    name: "Linehaul Schedule",
    meta: { permission: 'linehaul_view', login: true, subheader: 'Delivery' },
    icon: "fas fa-calendar",
    component: LinehaulSchedule,
  },
  {
    path: "/linehaul-calculator",
    name: "Linehaul Calculator",
    meta: { permission: 'linehaul_view', login: true, subheader: 'Client tools', internalOnly: true, internalOnlyBypass: 'client_tools' },
    icon: "fas fa-calculator",
    component: LinehaulCalculator,
  },
  {
    path: "/production",
    name: "Production",
    meta: { permission: 'inventory_view', login: true, subheader: 'Delivery' },
    icon: "fas fa-box-open",
    component: Production,
  },
  {
    path: "/manifest",
    name: "Manifests",
    meta: { permission: 'manifest_view', login: true, subheader: 'Manage' },
    icon: "fas fa-file-upload",
    component: ManifestsPage,
  },
  {
    path: "/invoices",
    name: "Invoices",
    meta: { permission: 'invoice_view', login: true, subheader: 'Manage', internalOnly: true },
    icon: "fas fa-file-invoice-dollar",
    component: InvoiceUI,
  },
  {
    path: "/invoiceUpload",
    name: "Invoices Upload",
    icon: "fas fa-upload",
    meta: { permission: 'invoice_upload', login: true, subheader: 'Manage', internalOnly: true },
    component: InvoicesUpload,
  },
  {
    path: "/clients",
    name: "Clients",
    meta: { permission: 'client_view', login: true, subheader: 'Admin' },
    icon: "fas fa-users",
    component: ClientsPage,
  },
  {
    path: "/linehaulpricing",
    name: "LineHaul",
    meta: { permission: 'client_pricing_view', login: true, subheader: 'Client pricing', internalOnly: true },
    icon: "fas fa-truck-moving",
    component: LineHaulPricing,
  },
  {
    path: "/fuellevypricing",
    name: "Fuel Levy",
    meta: { permission: 'client_pricing_view', login: true, subheader: 'Client pricing', internalOnly: true },
    icon: "fas fa-gas-pump",
    component: FuelLevyPricing,
  },
  {
    path: "/pickpackpricing",
    name: "Pick Pack",
    meta: { permission: 'client_pricing_view', login: true, subheader: 'Client pricing', internalOnly: true },
    icon: "fas fa-box",
    component: PickPackPricing,
  },
  {
    path: "/deliverysurchargepricing",
    name: "Delivery Surcharge",
    meta: { permission: 'client_pricing_view', login: true, subheader: 'Client pricing', internalOnly: true },
    icon: "fas fa-shipping-fast",
    component: DeliverySurchargePricing,
  },
  {
    path: "/palletstoragepricing",
    name: "Pallet Storage",
    meta: { permission: 'client_pricing_view', login: true, subheader: 'Client pricing', internalOnly: true },
    icon: "fas fa-pallet",
    component: PalletStoragePricing,
  },
  {
    path: "/permissions_manage",
    name: "Permissions Manage",
    meta: { permission: 'admin', login: true, subheader: 'Manage', internalOnly: true },
    icon: "fas fa-user-friends",
    component: PermissionsManage,
  },
  {
    path: "/edit-client",
    name: "EditClient",
    meta: { permission: 'client_edit', login: true, subheader: false, internalOnly: true },
    icon: "fas fa-users",
    component: EditClient,
  },

  {
    path: "/new-client",
    name: "NewClient",
    meta: { permission: 'client_edit', login: true, subheader: false, internalOnly: true },
    icon: "fas fa-users",
    component: EditClient,
  },

  {
    path: "/create_client",
    name: "Create Client",
    meta: { permission: 'client_edit', subheader: false },
    icon: "fas fa-user-circle",
    component: CreateClient,
  },

  {
    path: "/client_application",
    name: "Client Applications",
    meta: { permission: 'client_edit', login: true, subheader: 'Admin' },
    icon: "fas fa-user-circle",
    component: ClientApplicationPage,
  },
  {
    path: "/client-access",
    name: "Client Access",
    meta: { permission: 'admin', login: true, subheader: 'Admin', internalOnly: true },
    icon: "fas fa-link",
    component: ClientAccess,
  },
  {
    path: "/audit_logs",
    name: "Audit Logs",
    meta: { permission: 'admin', login: true, subheader: 'Admin', internalOnly: true },
    icon: "fas fa-tachometer-alt",
    component: LogsDisplayer,
  },
  {
    path: "/manage_manifests",
    name: "Manifest Formats",
    meta: { permission: 'manifest_definition_edit', login: true, subheader: 'Admin', internalOnly: true },
    icon: "fas fa-file-code",
    component: ManageManifests,
  },
  {
    path: "/manage_device",
    name: "Devices",
    meta: { permission: 'phone_view', login: true, subheader: 'Manage', internalOnly: true },
    icon: "phone",
    component: ManageDevices,
  },
  {
    path: "/global_admin",
    name: "Global Admin",
    meta: { permission: 'admin', login: true, header: false, subheader: 'Admin', internalOnly: true },
    icon: "fa fa-user-shield",
    component: GlobalAdmin,
  },
  {
    path: "/contractors",
    name: "Contractors",
    meta: { permission: "contractors_view", login: true, subheader: 'Manage', internalOnly: true },
    icon: "work",
    component: ContractorsPage
  },
  {
    path: "/becoolinfo",
    name: "BeCool Info",
    meta: { permission: "becoolinfo_view", login: true, subheader: 'Manage', internalOnly: true },
    icon: "info",
    component: BecoolInfo
  },
  {
    path: "/manage_items",
    name: "Manage items",
    meta: { permission: "inventory_view", login: true, subheader: 'Inventory' },
    icon: "fas fa-boxes",
    component: ManageItems
  },

  {
    path: "/manage_orders",
    name: "Manage orders",
    meta: { permission: "inventory_view", login: true, subheader: 'Inventory' },
    icon: "fas fa-boxes",
    component: ManageOrders
  },
  {
    path: "/faq",
    name: "API FAQ",
    meta: { permission: "api_documentation_view", login: true, header: true, subheader: false },
    icon: "fas fa-boxes",
    component: FAQ
  },
  {
    path: "/demo",
    name: "Demo",
    meta: { permission: "admin", login: true, header: false, subheader: 'Admin' },
    icon: "fas fa-flag-checkered",
    component: Demo
  },
  {
    path: "/network",
    name: "Network",
    meta: { permission: 'admin', login: true, subheader: 'Admin' },
    icon: "fas fa-wifi",
    component: Network,
  },
  {
    path: "/templates",
    name: "Templates",
    meta: { permission: "admin", login: true, header: false, subheader: 'Admin', internalOnly: true },
    icon: "fas fa-book-open",
    component: Templates
  },
  {
    path: "/set",
    name: "Setting",
    meta: { permission: "admin", login: true, header: false, subheader: 'Admin' },
    icon: "fas fa-cog",
    component: Setting
  },
  {
    path: "/jobs",
    name: "Jobs",
    meta: { permission: "admin", login: true, header: false, subheader: 'Admin' },
    icon: "fas fa-sync",
    component: Jobs
  },
  {
    path: "/key_manager",
    name: "Keys Manager",
    meta: { permission: 'vendor_admin', login: true, header: false, subheader: 'Manage', internalOnly: false },
    icon: "fas fa-keycdn",
    component: ManageKeys
  },
  {
    path: "/key_manager_internal",
    name: "Keys Manager",
    meta: { permission: 'admin', login: true, header: false, subheader: 'Manage', internalOnly: true },
    icon: "fas fa-keycdn",
    component: ManageKeys
  },
];
const router = new VueRouter({
  routes: routes,
  mode: 'history'
});


router.beforeEach((to, from, next) => {
  if (to.meta.login !== undefined) {
    if (store.store.state.auth.is_logged_in) {
      if (store.store.getters['auth/isInternalUser'] || !to.meta.internalOnly || (to.meta.internalOnlyBypass && store.store.getters['auth/hasPermission'](to.meta.internalOnlyBypass))) {
        if (to.meta.internalOnlyBypass && store.store.getters['auth/hasPermission'](to.meta.internalOnlyBypass)) {
          next();
        } else if (to.meta.permission !== undefined) {
          if (store.store.getters['auth/hasPermission'](to.meta.permission)) {
            next();
          } else {
            console.log('Invalid permissions for route');
            next('/');
          }
        } else {
          next()
        }
      } else {
        console.log('Not internal user');
        next('/');
      }
    } else {
      console.log('Not logged in');
      store.store.commit('auth/setRedirect', to.fullPath);
      next('/login');
    }
  } else {
    next()
  }
}
);


export default {
  router: router,
  routes: routes,
};



// WEBPACK FOOTER //
// ./src/modules/router/index.js